export {
  createScopedRequestGate as createAuditRequestGate,
  isScopedRequestCanceled as isAuditRequestCanceled,
} from "../utils/scopedRequestGate";

// Quand la pagination est déjà sur la première page, aucun changement d'état
// ne relancera l'effet de chargement : l'action doit donc charger directement.
// Depuis une autre page, le changement vers la page 1 suffit et évite une
// seconde requête concurrente déclenchée par l'effet React.
export const shouldLoadAuditPageImmediately = (currentPage) =>
  Number(currentPage) === 1;
